import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef } from 'react';
import initI18n from '../services/initI18n';
const useI18n = configuration => {
  const $ = _c(6);
  const initPromise = useRef(null);
  const [areTranslationsLoaded, setAreTranslationsLoaded] = useState(false);
  let t0;
  let t1;
  if ($[0] !== configuration) {
    t0 = () => {
      if (!initPromise.current) {
        initPromise.current = initI18n(configuration).then(() => setAreTranslationsLoaded(true));
      }
    };
    t1 = [configuration];
    $[0] = configuration;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      initPromise.current = undefined;
      setAreTranslationsLoaded(false);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const clear = t2;
  let t3;
  if ($[4] !== areTranslationsLoaded) {
    t3 = {
      areTranslationsLoaded,
      clear
    };
    $[4] = areTranslationsLoaded;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default useI18n;